'use strict';
import {makeActionCreator} from '../../core-utilities/redux';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {ManageAccessModalController} from './ManageAccessModalController';
import modalTemplate from './modal.html';
import {logger} from './logger';


export const showManageAccess = makeActionCreator('manage-access', 'show');

export const epics = [
  onShowManageAccess,
];

onShowManageAccess.$inject = [
  '$modal',
];

/**
 * @param {ActionsObservable<ReduxAction>} action$
 * @param {Store} store
 * @param {Object} dependencies
 * @return {Observable.<ReduxAction>}
 */
export function onShowManageAccess(action$, store, dependencies) {
  return action$.ofType(showManageAccess.TYPE)
    .switchMap(action => dependencies.$modal.show({
      template: modalTemplate,
      controller: ManageAccessModalController,
      locals: {
        targetDomain: action.payload.target,
      },
    }))
    .filter(() => false)
    .catch(epicErrorHandler(logger, 'onShowManageAccess'));
}



// WEBPACK FOOTER //
// ./src/js/core-components/manage-access/redux.js